import { n as __toESM } from "./chunk.rolldown-runtime_v20260917.js";
import { t as posthog_default } from "./chunk.posthog_v20260917.js";
import { p as require_react } from "./chunk.headless_v20260917.js";
import { n as require_client, t as require_jsx_runtime } from "./chunk.react_v20260917.js";
import { _ as IconMap, a as pushChangeLocation, c as pushFittingAvailabilityLoaded, d as pushSelectAppointment, f as IconClock, g as useFittingTranslations, h as FittingTranslationsProvider, i as pushBeginFitting, l as pushFittingError, m as FormTextField, n as parseFittingTranslationsFromDom, o as pushCustomerInformation, p as decodeHtml, r as pushAppointmentBooking, s as pushFittingAvailabilityEmpty, u as pushFittingExperience, v as IconPhone } from "./chunk.fittingTranslationsDom_v20260917.js";
import { t as DialogHelpOpener } from "./chunk.DialogHelpOpener_v20260917.js";
//#region src/components/Acuity/WorkTypes.jsx
var import_client = require_client();
var import_react = /* @__PURE__ */ __toESM(require_react(), 1);
var import_jsx_runtime = require_jsx_runtime();
var WorkTypes = ({ filteredWorkTypes, onWorkTypeSelect, selectedWorkTypeId, selectedStoreName, selectedStoreObj }) => {
	const { translations } = useFittingTranslations();
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "content-lg mx-auto",
		children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("h2", {
			className: "h2 mb-2 text-center",
			children: translations?.workTypesTitle.replace("{storeName}", selectedStoreName)
		}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
			className: "rte",
			children: (selectedStoreObj.address || selectedStoreObj.phone) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
				className: "flex w-full flex-col gap-2",
				children: [selectedStoreObj.address && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
						className: "h-4 w-4",
						children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconMap, { size: "16" })
					}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("a", {
						href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedStoreObj.address)}`,
						target: "_blank",
						rel: "noopener noreferrer",
						children: selectedStoreObj.address
					})]
				}), selectedStoreObj.phone && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
						className: "h-4 w-4",
						children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconPhone, { size: "16" })
					}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("a", {
						href: selectedStoreObj.hrefFormattedPhoneNumber,
						children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
							className: "sr-only",
							children: `Call ${selectedStoreObj.name}`
						}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
							"aria-hidden": "true",
							children: selectedStoreObj.phone
						})]
					})]
				})]
			})
		})]
	}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "content-lg mx-auto mb-5",
		children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("h3", {
			className: "h3 center-line text-center",
			id: "work-types-heading",
			children: translations?.selectFitting
		}), translations?.workTypesHeaderContent ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", { children: translations.workTypesHeaderContent }) : null]
	}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
		className: "grid grid-cols-1 items-start gap-4 lg:grid-cols-3",
		role: "radiogroup",
		"aria-labelledby": "work-types-heading",
		children: filteredWorkTypes.map((workType) => {
			const optionId = `work-type-${workType.id}`;
			const isSelected = selectedWorkTypeId === workType.id;
			const hasDescription = Boolean(workType.description);
			return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
				className: "rounded-lg",
				style: { backgroundColor: "#f2eddd" },
				children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
					className: `field-outline-host field-outline rounded-lg border border-shadow-black bg-fairway-light p-4 ${isSelected ? "field-outline--active" : ""}`,
					children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("label", {
						className: "cursor-pointer items-start",
						children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
							id: optionId,
							type: "radio",
							name: "acuity-work-type",
							className: "field-radio",
							value: workType.id,
							checked: isSelected,
							onChange: () => onWorkTypeSelect(workType),
							"aria-labelledby": `${optionId}-name`,
							"aria-describedby": hasDescription ? `${optionId}-desc` : void 0,
							style: { marginTop: "0.5rem" }
						}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
							className: "flex min-w-0 flex-1 flex-col gap-1",
							children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
								id: `${optionId}-name`,
								className: "text-left font-display text-lg font-semibold capitalize not-italic",
								children: workType.name
							}), hasDescription ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
								id: `${optionId}-desc`,
								className: "block text-xs opacity-75",
								children: workType.description
							}) : null]
						})]
					})
				}, workType.id), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DialogHelpOpener, {
					dialogSelector: `#fitting-help-${workType.id}-dialog`,
					ariaLabel: translations?.whatToExpect,
					showLabel: true,
					class: "block px-4 py-2"
				})]
			});
		})
	})] })] });
};
//#endregion
//#region src/components/Acuity/WorkTypesTrackTime.jsx
var WorkTypesTrackTime = ({ translations, workType, onWorkTypeSelect, selectedWorkTypeId }) => {
	const optionId = `work-type-${workType.id}`;
	const isSelected = selectedWorkTypeId === workType.id;
	const hasDescription = Boolean(workType.description);
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "content-lg mx-auto",
		children: [
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("h3", {
				className: "h3 center-line text-center",
				id: "work-types-track-time-heading",
				children: translations?.selectTrackTime
			}),
			translations?.trackTimeWorkTypesHeaderContent ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
				class: "mb-5",
				children: translations.trackTimeWorkTypesHeaderContent
			}) : null,
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				role: "radiogroup",
				"aria-labelledby": "work-types-track-time-heading",
				children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
					className: "rounded-lg",
					style: { backgroundColor: "#f2eddd" },
					children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
						className: `field-outline-host field-outline rounded-lg border border-shadow-black bg-fairway-light p-4 ${isSelected ? "field-outline--active" : ""}`,
						children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("label", {
							className: "cursor-pointer items-start",
							children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
								id: optionId,
								type: "radio",
								name: "acuity-work-type",
								className: "field-radio",
								value: workType.id,
								checked: isSelected,
								onChange: () => onWorkTypeSelect(workType),
								"aria-labelledby": `${optionId}-name`,
								"aria-describedby": hasDescription ? `${optionId}-desc` : void 0,
								style: { marginTop: "0.5rem" }
							}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
								className: "flex min-w-0 flex-1 flex-col gap-1",
								children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
									id: `${optionId}-name`,
									className: "text-left font-display text-lg font-semibold capitalize not-italic",
									children: workType.name
								}), hasDescription ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
									id: `${optionId}-desc`,
									className: "block text-xs opacity-75",
									children: workType.description
								}) : null]
							})]
						})
					})
				})
			})
		]
	});
};
//#endregion
//#region src/components/Acuity/CustomerInformationForm.jsx
var CustomerInformationForm = ({ onSubmit, storeAcuityLocale, loggedInCustomerData, submitDisabled = false }) => {
	const { translations } = useFittingTranslations();
	const [firstName, setFirstName] = (0, import_react.useState)("");
	const [lastName, setLastName] = (0, import_react.useState)("");
	const [phone, setPhone] = (0, import_react.useState)("");
	const [email, setEmail] = (0, import_react.useState)("");
	const [certificate, setCertificate] = (0, import_react.useState)("");
	const [stayInformed, setStayInformed] = (0, import_react.useState)(false);
	const [smsOptIn, setSmsOptIn] = (0, import_react.useState)(false);
	(0, import_react.useEffect)(() => {
		if (loggedInCustomerData) {
			setFirstName(loggedInCustomerData.customerFirstName);
			setLastName(loggedInCustomerData.customerLastName);
			setEmail(loggedInCustomerData.customerEmail);
			setPhone(loggedInCustomerData.customerPhone);
			setStayInformed(Boolean(loggedInCustomerData.customerAcceptsMarketing));
		} else if (Shopify.country === "US") setStayInformed(true);
		const referral = typeof window.getReferralValue === "function" ? window.getReferralValue() : "";
		if (referral) setCertificate(referral);
	}, []);
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (submitDisabled) return;
		const acuityCustomerInfo = {
			firstName,
			lastName,
			phone,
			email,
			certificate,
			stayInformed,
			...storeAcuityLocale === "en_US" && { smsOptIn }
		};
		try {
			await fetch("/apps/pxg/v1/customer-upsert", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					email,
					input: {
						firstName,
						lastName,
						email,
						phone,
						emailMarketingConsent: {
							marketingState: stayInformed ? "SUBSCRIBED" : "UNSUBSCRIBED",
							marketingOptInLevel: "SINGLE_OPT_IN",
							consentUpdatedAt: (/* @__PURE__ */ new Date()).toISOString()
						}
					}
				})
			});
		} catch (err) {
			console.error("Error submitting customer info:", err);
		}
		onSubmit(acuityCustomerInfo);
	};
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("form", {
		onSubmit: handleSubmit,
		className: "flex flex-col gap-6",
		children: [
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
				type: "hidden",
				id: "bookFittingForm",
				name: "bookFittingForm",
				value: "book-fitting",
				readOnly: true
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormTextField, {
				id: "customerInfoFormFirstName",
				value: firstName,
				onChange: (e) => setFirstName(e.target.value),
				label: translations?.piiFirstName,
				required: true
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormTextField, {
				id: "customerInfoFormLastName",
				value: lastName,
				onChange: (e) => setLastName(e.target.value),
				label: translations?.piiLastName,
				required: true
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormTextField, {
				id: "customerInfoFormTel",
				type: "tel",
				value: phone,
				onChange: (e) => setPhone(e.target.value),
				label: translations?.piiPhone,
				required: true
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormTextField, {
				id: "customerInfoFormEmail",
				type: "email",
				value: email,
				onChange: (e) => setEmail(e.target.value),
				label: translations?.piiEmail,
				required: true
			}),
			storeAcuityLocale === "en_US" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
				className: "flex flex-col",
				children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("label", {
					className: "font-bold",
					htmlFor: "smsOptIn",
					children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
						id: "smsOptIn",
						type: "checkbox",
						className: "field-checkbox",
						checked: smsOptIn,
						onChange: (e) => setSmsOptIn(e.target.checked)
					}), translations?.acuitySmsOptInLabel]
				}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
					className: "field-help",
					children: translations?.piiSmsOptInDetails
				})]
			}) }),
			/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
				className: "flex flex-col",
				children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("label", {
					htmlFor: "customerInfoStayInformed",
					children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
						type: "checkbox",
						id: "customerInfoStayInformed",
						className: "field-checkbox",
						checked: stayInformed,
						onChange: (e) => setStayInformed(e.target.checked)
					}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", { children: [translations?.piiMarketingOptIn, " "] })]
				}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
					className: "field-help",
					children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("a", {
						target: "_blank",
						className: "underline",
						href: "/policies/privacy-policy",
						children: translations?.piiPrivacyPolicy
					})
				})]
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				className: "py-2",
				children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormTextField, {
					id: "customerInfoFormPromoCode",
					value: certificate,
					onChange: (e) => setCertificate(e.target.value),
					label: translations?.piiReferralCode
				})
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
				className: "btn",
				type: "submit",
				disabled: submitDisabled,
				children: translations?.appointmentBookingButtonText
			})
		]
	});
};
//#endregion
//#region src/components/Acuity/LoadingIndicator.jsx
var LoadingIndicator = ({ displayedText }) => {
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "mt-5 mx-auto flex flex-col h-44 w-full items-center justify-center",
		role: "status",
		children: [
			displayedText && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
				className: "mt-2 mb-4 text-center text-md text-shadow-black",
				children: displayedText
			}) }),
			/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", {
				"aria-hidden": "true",
				className: "inline h-8 w-8 animate-spin fill-gray-600 text-gray-200 dark:fill-gray-300 dark:text-gray-600",
				viewBox: "0 0 100 101",
				fill: "none",
				xmlns: "http://www.w3.org/2000/svg",
				children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
					d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
					fill: "currentColor"
				}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
					d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
					fill: "currentFill"
				})]
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
				className: "sr-only",
				children: "Loading..."
			})
		]
	});
};
//#endregion
//#region src/components/Acuity/FittingErrorMessage.jsx
/**
* Shared error callout for book-a-fitting (calendar load, no slots, booking failure).
*
* @param {Object} props
* @param {string} [props.message] - HTML string from theme translations (e.g. `noAppointmentsHelpText`)
* @param {string} [props.text] - Plain-text message (preferred for API error strings)
* @param {string} [props.className] - Optional extra classes on the inner wrapper
*/
var FittingErrorMessage = ({ message, text, className = "" }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
	className: "alert content-lg mx-auto",
	role: "alert",
	children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
		className: "p-4",
		children: text ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
			className: ["text-balance text-lg text-center", className].filter(Boolean).join(" "),
			style: { fontFamily: "var(--font-display)" },
			children: text
		}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
			className: ["rte text-balance text-lg text-center", className].filter(Boolean).join(" "),
			style: { fontFamily: "var(--font-display)" },
			dangerouslySetInnerHTML: { __html: decodeHtml(message || "") }
		})
	})
});
//#endregion
//#region src/utils/normalizeFittingType.js
/**
* Normalize Acuity appointment type names for display and analytics.
* Trims whitespace and unifies curly apostrophes so breakdowns do not fragment.
*
* @param {unknown} name
* @returns {string}
*/
function normalizeFittingType(name) {
	return String(name ?? "").trim().replace(/[\u2018\u2019]/g, "'");
}
//#endregion
//#region src/components/Acuity/BookingSuccess.jsx
var BookingSuccess = ({ bookAnotherAppointmentHandler }) => {
	const { translations } = useFittingTranslations();
	const success = translations?.bookingSuccessFailure;
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "w-full",
		children: [
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("img", {
				src: success?.image,
				alt: success?.imageAltText
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				className: "my-5 text-sm leading-8",
				dangerouslySetInnerHTML: { __html: decodeHtml(success?.body) }
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				className: "flex justify-center gap-6",
				children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
					onClick: () => bookAnotherAppointmentHandler(true),
					className: "btn btn--secondary flex-1 py-2 text-sm",
					children: success?.bookAnotherFittingButtonText
				})
			}),
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)("img", {
				height: "1",
				width: "1",
				alt: "",
				src: "https://insight.adsrvr.org/track/pxl/?adv=2kx0l3b&ct=0:r98l2mm&fmt=3"
			})
		]
	});
};
//#endregion
//#region src/components/Acuity/FinalBooking.jsx
var MAX_SLOT_FAILURES_BEFORE_HELP = 3;
var TRACK_TIME_NOT_AVAILABLE_ERROR = "Track Time Not Available";
var FinalBooking = ({ selectedStoreObj, finalBookingObject, finalBookingRef, bookAnotherAppointmentHandler, onBookingFailure, selectedTime, storeAcuityLocale, dataLayerErrorHandler, addOn, selectedWorkTypeAvailableAddOns, selectedCalendarIds, loggedInCustomerData }) => {
	const { translations } = useFittingTranslations();
	const [bookingStatus, setBookingStatus] = (0, import_react.useState)(null);
	const [loading, setLoading] = (0, import_react.useState)(false);
	const [addonIds, setAddonIds] = (0, import_react.useState)(/* @__PURE__ */ new Set());
	const [failureText, setFailureText] = (0, import_react.useState)(null);
	const [consecutiveFailures, setConsecutiveFailures] = (0, import_react.useState)(0);
	const [requireNewSlot, setRequireNewSlot] = (0, import_react.useState)(false);
	const [submitLocked, setSubmitLocked] = (0, import_react.useState)(false);
	(0, import_react.useEffect)(() => {
		if (selectedTime && !submitLocked) setRequireNewSlot(false);
	}, [selectedTime, submitLocked]);
	const resolveFailureCopy = (apiError, apiMessage) => {
		if (apiError === TRACK_TIME_NOT_AVAILABLE_ERROR) return translations?.trackTimeNotAvailable || apiMessage;
		return apiMessage || translations?.bookingSuccessFailure?.bookingFailureErrorMessage || translations?.cdpErrorGeneric;
	};
	const captureBookingFailed = ({ workTypeName, appointmentTypeId, errorType, statusCode, error, errorMessage, httpStatus }) => {
		posthog_default.capture("fitting_appointment_failed", {
			location_name: selectedStoreObj.name,
			fitting_type: normalizeFittingType(workTypeName),
			appointment_type_id: appointmentTypeId,
			error_type: errorType,
			status_code: statusCode ?? null,
			error: error ?? null,
			error_message: errorMessage ?? null,
			http_status: httpStatus ?? null
		});
	};
	const applyBookingFailure = ({ errorType, statusCode, error, errorMessage, httpStatus, workTypeName, appointmentTypeId, blockFurtherSubmits = false }) => {
		setBookingStatus("failure");
		setFailureText(resolveFailureCopy(error, errorMessage));
		setConsecutiveFailures((count) => count + 1);
		if (blockFurtherSubmits) {
			setSubmitLocked(true);
			setRequireNewSlot(true);
		} else setRequireNewSlot(true);
		onBookingFailure?.({ blockFurtherSubmits });
		captureBookingFailed({
			workTypeName,
			appointmentTypeId,
			errorType,
			statusCode,
			error,
			errorMessage,
			httpStatus
		});
	};
	const handleBookingSubmission = async (data) => {
		setLoading(true);
		const { workType, workTypeName, dateTimeReadable, ...filteredData } = data;
		filteredData.locale = storeAcuityLocale;
		filteredData.calendarIds = selectedCalendarIds;
		try {
			const httpResponse = await fetch(`https://${Shopify.pxgApiEndpoint}/acuity/schedule-appointment`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(filteredData)
			});
			const response = await httpResponse.json().catch(() => ({}));
			if (!httpResponse.ok) {
				const errorType = "Server Error";
				dataLayerErrorHandler("dl_fitting_error", "appointmentBooking", errorType, JSON.stringify({
					status_code: response.status_code,
					message: response.message || `Server error: ${httpResponse.status}`,
					response
				}));
				applyBookingFailure({
					errorType,
					statusCode: response.status_code,
					error: response.error,
					errorMessage: response.message || `Server error: ${httpResponse.status}`,
					httpStatus: httpResponse.status,
					workTypeName: data.workTypeName,
					appointmentTypeId: data.appointmentTypeId
				});
				if (httpResponse.status >= 500) posthog_default.captureException(new Error(response.message || `Server error: ${httpResponse.status}`));
				return;
			}
			if (response.status_code === 0) {
				setBookingStatus("success");
				setFailureText(null);
				setConsecutiveFailures(0);
				setRequireNewSlot(false);
				setSubmitLocked(false);
				pushCustomerInformation({
					locationName: selectedStoreObj.name,
					firstName: data.firstName,
					lastName: data.lastName,
					email: data.email,
					phoneNumber: data.phone
				});
				pushAppointmentBooking({
					locationName: selectedStoreObj.name,
					workTypeName: data.workTypeName,
					appointmentTypeId: data.appointmentTypeId,
					dateTimeReadable: data.dateTimeReadable,
					appointmentId: response.appointment.id,
					storeAcuityLocale,
					firstName: data.firstName,
					lastName: data.lastName,
					email: data.email,
					phoneNumber: data.phone
				});
				posthog_default.capture("fitting_appointment_booked", {
					location_name: selectedStoreObj.name,
					fitting_type: normalizeFittingType(data.workTypeName),
					appointment_type_id: data.appointmentTypeId
				});
				const customerId = window.Shopify?.customer?.id;
				if (customerId) posthog_default.identify(`shopify_${customerId}`, { $set: {
					first_name: data.firstName,
					last_name: data.lastName
				} });
			} else {
				const errorType = "Server Error";
				dataLayerErrorHandler("dl_fitting_error", "appointmentBooking", errorType, JSON.stringify({
					status_code: response.status_code,
					message: response.message || "Booking failed - no message in response",
					response
				}));
				applyBookingFailure({
					errorType,
					statusCode: response.status_code,
					error: response.error,
					errorMessage: response.message || "Booking failed - no message in response",
					httpStatus: httpResponse.status,
					workTypeName: data.workTypeName,
					appointmentTypeId: data.appointmentTypeId,
					blockFurtherSubmits: response.error === TRACK_TIME_NOT_AVAILABLE_ERROR
				});
				console.error("Booking failed response:", response);
			}
		} catch (error) {
			console.error("Error:", error);
			let errorType = "FrontEnd JS";
			if (error.status) errorType = "Server Error";
			else if (error instanceof TypeError) errorType = "Network";
			const serializedError = {
				name: error.name,
				message: error.message,
				stack: error.stack
			};
			dataLayerErrorHandler("dl_fitting_error", "appointmentBooking", errorType, JSON.stringify(serializedError));
			applyBookingFailure({
				errorType,
				statusCode: error.body?.status_code,
				error: error.body?.error,
				errorMessage: error.message,
				httpStatus: error.status,
				workTypeName: data.workTypeName,
				appointmentTypeId: data.appointmentTypeId
			});
			posthog_default.captureException(error);
			console.error("Error during booking submission:", serializedError);
		} finally {
			setLoading(false);
		}
	};
	const handleCustomerSubmit = (customerForm) => {
		if (requireNewSlot || submitLocked || !selectedTime) return;
		if (customerForm.certificate && typeof window !== "undefined" && typeof window.setReferralCookie === "function") window.setReferralCookie(customerForm.certificate);
		const combinedData = {
			...finalBookingObject,
			...customerForm
		};
		if (addonIds.size > 0) combinedData.addonIds = Array.from(addonIds);
		handleBookingSubmission(combinedData);
	};
	const addOnIdHandler = (checkedStatus, addOnId) => {
		setAddonIds((prev) => {
			const newSet = new Set(prev);
			if (newSet.has(addOnId) && !checkedStatus) newSet.delete(addOnId);
			else if (!newSet.has(addOnId) && checkedStatus === true) newSet.add(addOnId);
			return newSet;
		});
	};
	const submitDisabled = loading || requireNewSlot || submitLocked || !selectedTime;
	const showPhoneHelp = submitLocked || consecutiveFailures >= MAX_SLOT_FAILURES_BEFORE_HELP;
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "relative scroll-mt-[var(--nav-height)] outline-none",
		ref: finalBookingRef,
		tabIndex: -1,
		children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("h2", {
			className: "h3 mb-4 text-center",
			children: translations?.finalBookingTitle
		}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
			className: "content-lg mx-auto flex flex-col items-center justify-center",
			children: [
				/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
					class: "rte",
					children: [
						/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
							className: "flex w-full flex-col gap-2",
							children: [
								/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
									className: "flex items-center gap-2",
									children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
										className: "h-4 w-4",
										children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconClock, { size: "16" })
									}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { children: requireNewSlot && !submitLocked ? translations?.bookingFailureSelectAnotherTime : finalBookingObject.dateTimeReadable })]
								}),
								selectedStoreObj.address && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
									className: "flex items-center gap-2",
									children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
										className: "h-4 w-4",
										children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconMap, { size: "16" })
									}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("a", {
										href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedStoreObj.address)}`,
										target: "_blank",
										rel: "noopener noreferrer",
										children: selectedStoreObj.address
									})]
								}),
								selectedStoreObj.phone && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
									className: "flex items-center gap-2",
									children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
										className: "h-4 w-4",
										children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconPhone, { size: "16" })
									}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("a", {
										href: selectedStoreObj.hrefFormattedPhoneNumber,
										children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
											className: "sr-only",
											children: `Call ${selectedStoreObj.name}`
										}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
											"aria-hidden": "true",
											children: selectedStoreObj.phone
										})]
									})]
								})
							]
						}),
						/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("p", { children: [
							/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("b", { children: [finalBookingObject.workType.name, ":"] }),
							" ",
							finalBookingObject.workType.description
						] }),
						addOn && selectedWorkTypeAvailableAddOns.includes(addOn.id) && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
							className: "flex flex-col",
							children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("label", {
								className: "mb-2 inline-flex items-center",
								children: [
									/* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
										type: "checkbox",
										className: "field-checkbox",
										onChange: (e) => addOnIdHandler(e.target.checked, addOn.id)
									}),
									/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
										className: "font-bold",
										children: translations?.piiAddOnChallengeLabel
									}),
									" ",
									addOn.name
								]
							}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
								className: "field-help",
								dangerouslySetInnerHTML: { __html: decodeHtml(translations?.piiAddOnChallengeDescription) }
							})]
						})
					]
				}),
				/* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
					className: "relative mt-8 w-full",
					children: bookingStatus === "success" && !loading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BookingSuccess, { bookAnotherAppointmentHandler }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)(CustomerInformationForm, {
						onSubmit: handleCustomerSubmit,
						storeAcuityLocale,
						storeName: selectedStoreObj.name,
						bookAnotherAppointmentHandler,
						loggedInCustomerData,
						submitDisabled
					}), bookingStatus === "failure" && !loading && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
						className: "mt-4 flex flex-col gap-4",
						children: [failureText ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingErrorMessage, { text: failureText }) : null, showPhoneHelp ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingErrorMessage, { message: translations?.noAppointmentsHelpText }) : null]
					})] })
				}),
				loading && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
					className: "absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-white/70",
					children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingIndicator, {})
				})
			]
		})]
	});
};
//#endregion
//#region src/components/icons/IconChevronLeft.jsx
var IconChevronLeft = ({ size = 6 }) => {
	return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		className: `size-6 w-${size} h-${size}`,
		children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M15.75 19.5 8.25 12l7.5-7.5"
		})
	}) });
};
//#endregion
//#region src/components/icons/IconChevronRight.jsx
var IconChevronRight = ({ size = 6 }) => {
	return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		className: `size-6 w-${size} h-${size}`,
		children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m8.25 4.5 7.5 7.5-7.5 7.5"
		})
	}) });
};
//#endregion
//#region src/components/icons/IconChevronDown.jsx
var IconChevronDown = ({ inlineOrBlock = "inline", rotate = false }) => {
	return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		className: `${inlineOrBlock}`,
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		style: {
			transition: "transform 0.3s ease",
			transform: rotate ? "rotate(-180deg)" : "rotate(0deg)"
		},
		children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
			d: "M18 9.99984L16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984Z",
			fill: "#201E25"
		})
	});
};
//#endregion
//#region src/utils/acuityAvailabilityDayLimits.js
/** Minutes from local midnight before tomorrow's slots are shown (9:00 AM). */
var TOMORROW_VISIBLE_FROM_MINUTES = 540;
/**
* @param {Array<{ date: string; slots?: Array<{ timeZone?: string }> }>} availabilityByDay
* @returns {string | null}
*/
function resolveLocationTimeZone(availabilityByDay) {
	for (const day of availabilityByDay) for (const slot of day.slots || []) if (slot.timeZone) return slot.timeZone;
	return null;
}
/**
* @param {string} timeZone - IANA timezone
* @param {Date} date
* @returns {number}
*/
function getMinutesSinceMidnightInTimeZone(timeZone, date) {
	const parts = new Intl.DateTimeFormat("en-US", {
		timeZone,
		hour: "numeric",
		minute: "numeric",
		hour12: false
	}).formatToParts(date);
	const hour = Number(parts.find((part) => part.type === "hour")?.value ?? 0);
	const minute = Number(parts.find((part) => part.type === "minute")?.value ?? 0);
	return hour * 60 + minute;
}
/**
* @param {string} timeZone
* @param {Date} date
* @returns {string}
*/
function formatYmdInTimeZone(timeZone, date) {
	return new Intl.DateTimeFormat("en-CA", {
		timeZone,
		year: "numeric",
		month: "2-digit",
		day: "2-digit"
	}).format(date);
}
/**
* @param {string} ymd - `YYYY-MM-DD`
* @param {number} days
* @returns {string}
*/
function addCalendarDays(ymd, days) {
	const [y, m, d] = ymd.split("-").map(Number);
	return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}
/**
* @param {string} timeZone - IANA timezone
* @param {Date} [now]
* @returns {Set<string>} `YYYY-MM-DD` wall dates allowed in `timeZone` (today always; tomorrow from 9:00 AM)
*/
function getAllowedDatesInTimeZone(timeZone, now = /* @__PURE__ */ new Date()) {
	const today = formatYmdInTimeZone(timeZone, now);
	if (getMinutesSinceMidnightInTimeZone(timeZone, now) < TOMORROW_VISIBLE_FROM_MINUTES) return /* @__PURE__ */ new Set([today]);
	return /* @__PURE__ */ new Set([today, addCalendarDays(today, 1)]);
}
/**
* @template {Object} T
* @param {Array<T & { date: string; slots?: Array<{ timeZone?: string }> }>} availabilityByDay
* @param {Date} [now]
* @returns {Array<T & { date: string; slots?: Array<{ timeZone?: string }> }>}
*/
function filterAvailabilityDaysByTimeZone(availabilityByDay, now = /* @__PURE__ */ new Date()) {
	const timeZone = resolveLocationTimeZone(availabilityByDay);
	if (!timeZone) return availabilityByDay;
	const allowedDates = getAllowedDatesInTimeZone(timeZone, now);
	return availabilityByDay.filter((day) => allowedDates.has(day.date));
}
//#endregion
//#region src/components/Acuity/Calendar.jsx
var Calendar = ({ calendarRef, workTypeId, onlyTodayAndTomorrow = false, calendarIds, onAppointmentSelect, refreshCalendar, setRefreshCalendar, selectedTime, getDateFromString, fullLocaleString, storeAcuityLocale, hour12Format, capitalizeFirstLetters, selectedStoreName, workTypeName, dataLayerErrorHandler, fetchedStartDates, setFetchedStartDates, firstDateToQuery, setFirstDateToQuery }) => {
	const { translations } = useFittingTranslations();
	const [calendarData, setCalendarData] = (0, import_react.useState)([]);
	const [loading, setLoading] = (0, import_react.useState)(false);
	const [transitioning, setTransitioning] = (0, import_react.useState)(false);
	const [lastDayReturned, setLastDayReturned] = (0, import_react.useState)(null);
	const [previousPaginationDisabled, setPreviousPaginationDisabled] = (0, import_react.useState)(true);
	const [dateRangeStart, setDateRangeStart] = (0, import_react.useState)(null);
	const [dateRangeEnd, setDateRangeEnd] = (0, import_react.useState)(null);
	const [appointmentsAvailable, setAppointmentsAvailable] = (0, import_react.useState)(null);
	const [userPaginated, setUserPaginated] = (0, import_react.useState)(false);
	const [calendarFetchError, setCalendarFetchError] = (0, import_react.useState)(false);
	const getFormattedDate = (date) => {
		return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;
	};
	const parseAndFormatDate = (dateString, lastDate) => {
		const [year, month, day] = dateString.split("-").map(Number);
		const date = new Date(year, month - 1, day);
		if (lastDate) setLastDayReturned(date);
		let shortMonth = date.toLocaleDateString(fullLocaleString, { month: "short" });
		let longMonth = date.toLocaleDateString(fullLocaleString, { month: "long" });
		if (fullLocaleString === "fr-CA") {
			shortMonth = capitalizeFirstLetters(shortMonth);
			longMonth = capitalizeFirstLetters(longMonth);
		}
		return {
			short: `${shortMonth} ${date.getDate()}`,
			long: `${longMonth} ${date.getDate()}`
		};
	};
	const cleanupTimeSlots = (data) => {
		return data.map((entry) => {
			const seenTimes = /* @__PURE__ */ new Set();
			const uniqueSlots = entry.slots.filter((slot) => {
				if (seenTimes.has(slot.time)) return false;
				seenTimes.add(slot.time);
				return true;
			}).sort((a, b) => new Date(a.time) - new Date(b.time));
			return {
				...entry,
				slots: uniqueSlots
			};
		});
	};
	/**
	* Sorts by date, dedupes slot times per day; caps at 5 days or filters to today/tomorrow in store TZ.
	* @returns {Array<{ date: string; slots: unknown[] }>}
	*/
	const sortAndFilterDatesAndTimes = (formattedCalendarData) => {
		const sortedCalendarData = cleanupTimeSlots(formattedCalendarData).sort((a, b) => new Date(a.date) - new Date(b.date));
		const limitedDataArray = onlyTodayAndTomorrow ? filterAvailabilityDaysByTimeZone(sortedCalendarData) : sortedCalendarData.slice(0, 5);
		setCalendarData(limitedDataArray);
		return limitedDataArray;
	};
	const fetchCalendarData = async (triggeredByPagination, paginationDateToQuery = null, addToFetchedDatesArray) => {
		if (onlyTodayAndTomorrow && triggeredByPagination) return;
		if (triggeredByPagination) setTransitioning(true);
		else setLoading(true);
		const dateToQuery = paginationDateToQuery || firstDateToQuery;
		try {
			setCalendarFetchError(false);
			const httpResponse = await fetch(`https://${Shopify.pxgApiEndpoint}/acuity/v2/availability`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					calendarIDs: calendarIds,
					date: getFormattedDate(dateToQuery),
					appointmentTypeId: workTypeId,
					locale: storeAcuityLocale
				})
			});
			if (!httpResponse.ok) {
				const err = /* @__PURE__ */ new Error(`Server error: ${httpResponse.status}`);
				err.status = httpResponse.status;
				throw err;
			}
			const response = await httpResponse.json();
			if (addToFetchedDatesArray !== false) setFetchedStartDates((prev) => [...prev, dateToQuery]);
			if (response.length === 0) {
				setAppointmentsAvailable(false);
				if (!triggeredByPagination) {
					const normalizedCalendarIds = (calendarIds ?? []).map((id) => Number(id));
					pushFittingAvailabilityEmpty({
						locationName: selectedStoreName ?? "",
						fittingExperience: workTypeName ?? "Fitting",
						appointmentTypeId: typeof workTypeId === "number" ? workTypeId : void 0,
						locale: storeAcuityLocale ?? "",
						calendarIdsRequested: normalizedCalendarIds,
						calendarIdsMatched: normalizedCalendarIds,
						emptyReason: "no_slots_returned"
					});
				}
			} else {
				const groupedData = response.reduce((accumulator, { time, slotsAvailable, calendarId, timeZone }) => {
					const date = time.split("T")[0];
					if (!accumulator[date]) accumulator[date] = [];
					accumulator[date].push({
						time,
						slotsAvailable,
						calendarId,
						timeZone
					});
					return accumulator;
				}, {});
				const formattedCalendarData = Object.keys(groupedData).map((date) => ({
					date,
					slots: groupedData[date]
				}));
				const limitedCalendarData = sortAndFilterDatesAndTimes(formattedCalendarData);
				if (limitedCalendarData.length === 0) {
					setAppointmentsAvailable(false);
					if (!triggeredByPagination) {
						const normalizedCalendarIds = (calendarIds ?? []).map((id) => Number(id));
						pushFittingAvailabilityEmpty({
							locationName: selectedStoreName ?? "",
							fittingExperience: workTypeName ?? "Fitting",
							appointmentTypeId: typeof workTypeId === "number" ? workTypeId : void 0,
							locale: storeAcuityLocale ?? "",
							calendarIdsRequested: normalizedCalendarIds,
							calendarIdsMatched: normalizedCalendarIds,
							emptyReason: "no_slots_returned"
						});
					}
				} else {
					setAppointmentsAvailable(true);
					const sortedDateStrings = limitedCalendarData.map((item) => item.date);
					setDateRangeStart(parseAndFormatDate(sortedDateStrings[0]));
					setDateRangeEnd(parseAndFormatDate(sortedDateStrings[sortedDateStrings.length - 1], true));
					if (!triggeredByPagination) {
						const daySummaries = limitedCalendarData.map((day) => ({
							date: day.date,
							timesPresentedCount: day.slots.length
						}));
						const totalTimesPresentedCount = daySummaries.reduce((sum, day) => sum + day.timesPresentedCount, 0);
						const normalizedCalendarIds = (calendarIds ?? []).map((id) => Number(id));
						pushFittingAvailabilityLoaded({
							locationName: selectedStoreName ?? "",
							fittingExperience: workTypeName ?? "Fitting",
							appointmentTypeId: typeof workTypeId === "number" ? workTypeId : void 0,
							locale: storeAcuityLocale ?? "",
							calendarIdsRequested: normalizedCalendarIds,
							calendarIdsMatched: normalizedCalendarIds,
							daysPresentedCount: daySummaries.length,
							totalTimesPresentedCount,
							daySummaries,
							firstAvailableDate: daySummaries[0]?.date ?? null
						});
					}
				}
			}
			if (!triggeredByPagination) pushFittingExperience({
				locationName: selectedStoreName,
				fittingExperience: workTypeName
			});
		} catch (error) {
			let errorType = "FrontEnd JS";
			if (error.status) errorType = "Server Error";
			else if (error instanceof TypeError) errorType = "Network";
			const serializedError = {
				name: error.name,
				message: error.message,
				stack: error.stack
			};
			dataLayerErrorHandler("dl_fitting_error", "fittingExperience", errorType, JSON.stringify(serializedError));
			console.error("Error fetching calendar dates and times:", serializedError);
			setCalendarFetchError(true);
		} finally {
			if (triggeredByPagination) setTransitioning(false);
			else setLoading(false);
			setRefreshCalendar(false);
		}
	};
	let tempWorkTypeId;
	(0, import_react.useEffect)(() => {
		if (refreshCalendar || workTypeId !== tempWorkTypeId) {
			fetchCalendarData(false);
			setUserPaginated(false);
			tempWorkTypeId = workTypeId;
		}
	}, [workTypeId, refreshCalendar]);
	const prevFetchedStartDatesRef = (0, import_react.useRef)();
	(0, import_react.useEffect)(() => {
		if (onlyTodayAndTomorrow) return;
		if (prevFetchedStartDatesRef.current && prevFetchedStartDatesRef.current.length > fetchedStartDates.length) {
			const previousPaginationFirstDateToQuery = fetchedStartDates[fetchedStartDates.length - 1];
			fetchCalendarData(true, previousPaginationFirstDateToQuery, false);
			if (fetchedStartDates.length <= 1) setPreviousPaginationDisabled(true);
		}
		prevFetchedStartDatesRef.current = fetchedStartDates;
	}, [fetchedStartDates, onlyTodayAndTomorrow]);
	const paginationHandler = (prevNext) => {
		if (onlyTodayAndTomorrow) return;
		if (prevNext === "next" && lastDayReturned) {
			const nextDay = new Date(lastDayReturned);
			nextDay.setDate(nextDay.getDate() + 1);
			setPreviousPaginationDisabled(false);
			setFirstDateToQuery(nextDay);
			fetchCalendarData(true, nextDay, true);
			setUserPaginated(true);
		} else if (prevNext === "prev") {
			setFetchedStartDates((prev) => prev.slice(0, prev.length - 1));
			setUserPaginated(true);
		}
	};
	return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
		className: "scroll-mt-[var(--nav-height)] outline-none",
		ref: calendarRef,
		tabIndex: -1,
		children: loading ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingIndicator, { displayedText: translations?.calendarSpinnerText }) : calendarFetchError ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
			className: "mt-4",
			children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingErrorMessage, { message: translations?.noAppointmentsHelpText })
		}) : appointmentsAvailable ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
			className: "relative",
			children: [transitioning && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				className: "absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-60",
				children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingIndicator, {})
			}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				className: transitioning ? "pointer-events-none opacity-50" : "",
				children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
					className: "content-lg mx-auto",
					children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
						className: `mb-4 flex items-center gap-4 ${onlyTodayAndTomorrow ? "justify-center" : "justify-between"}`,
						children: [
							!onlyTodayAndTomorrow ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
								onClick: () => paginationHandler("prev"),
								className: `btn order-1 box-content h-6 w-6 rounded-full p-0 active:bg-inherit ${previousPaginationDisabled ? "disabled opacity-50" : ""}`,
								disabled: previousPaginationDisabled,
								"aria-hidden": previousPaginationDisabled,
								...!previousPaginationDisabled && { "aria-label": "Go to previous page" },
								children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconChevronLeft, { size: "4" })
							}) : null,
							/* @__PURE__ */ (0, import_jsx_runtime.jsx)("h3", {
								className: `h3 ${onlyTodayAndTomorrow ? "" : "order-2"}`,
								children: dateRangeStart.short === dateRangeEnd.short ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
									className: "sr-only",
									children: dateRangeStart.long
								}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
									"aria-hidden": "true",
									children: dateRangeStart.short
								})] }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
									className: "sr-only",
									children: [
										dateRangeStart?.long,
										" through ",
										dateRangeEnd?.long
									]
								}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
									"aria-hidden": "true",
									children: [
										dateRangeStart?.short,
										" - ",
										dateRangeEnd?.short
									]
								})] })
							}),
							!onlyTodayAndTomorrow ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
								onClick: () => paginationHandler("next"),
								className: "btn order-3 box-content h-6 w-6 rounded-full p-0 active:bg-inherit",
								"aria-label": "Go to next page",
								children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconChevronRight, { size: "4" })
							}) : null
						]
					}), calendarData.map((dateObj, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("details", {
						className: "accordion mx-auto w-full",
						children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("summary", { children: [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
							className: "accordion__title",
							children: [
								getDateFromString(dateObj.date, "day"),
								", ",
								getDateFromString(dateObj.date, "monthDayShort"),
								/* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
									className: "pl-2 font-normal",
									children: [
										dateObj.slots.length > 6 ? "6+" : `${dateObj.slots.length}`,
										" ",
										translations?.fittingsAvailable
									]
								})
							]
						}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
							className: "accordion__icon",
							"aria-hidden": true,
							children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconChevronDown, {})
						})] }), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
							className: "accordion__content",
							children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
								className: "btn-container",
								children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
									className: "btn-grid",
									children: dateObj.slots.map((slot, slotIndex) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
										className: `field-pill-btn field-pill-btn--${selectedTime === slot.time ? "selected" : "unselected"}`,
										onClick: () => onAppointmentSelect(slot.time, slot.calendarId, slot.timeZone),
										children: new Date(slot.time).toLocaleTimeString(fullLocaleString, {
											hour: "numeric",
											minute: "2-digit",
											hour12: hour12Format,
											timeZone: slot.timeZone
										})
									}, slotIndex))
								})
							})
						})]
					}, index))]
				})
			})]
		}) : userPaginated && !onlyTodayAndTomorrow ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
			className: "flex flex-col items-center justify-center px-3 pt-5",
			children: [/* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
				onClick: () => paginationHandler("prev"),
				className: "btn rounded-full active:bg-inherit",
				"aria-label": "Back to previous dates",
				children: translations?.noAppointmentsPaginateBackButton
			}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
				className: "mt-4",
				children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingErrorMessage, { message: translations?.noAppointmentsHelpText })
			})]
		}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
			className: "mt-4",
			children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingErrorMessage, { message: translations?.noAppointmentsHelpText })
		})
	});
};
//#endregion
//#region src/components/Acuity/localization/workTypeTranslations.js
var workTypeTranslations = {
	ironsFitting: {
		ids: [
			7855171,
			36430420,
			34721173,
			32896711,
			39968849
		],
		en: {
			name: "Irons Fitting",
			description: "Fine-tune your scoring clubs with a PXG iron fitting. Our irons are a fast track to lowering your score. Explore and compare models like GEN7, 0317, and Black Ops irons."
		},
		fr: {
			name: "Les fers",
			description: "Ajuster avec précision vos fers PXG. Avec la face la plus mince de l'industrie du golf, nos fers Gen7, 0317 et black Ops sont la façon la plus facile de baisser vos pointages."
		},
		ja: {
			name: "アイアンフィッティング",
			description: "PXGのアイアンフィッティングで、スコアを伸ばすクラブを微調整しましょう。当社のアイアンは、スコアを伸ばす近道です。GEN7、0317、Black Opsアイアンなどのモデルを比較検討してください。"
		}
	},
	fullBagExperience: {
		ids: [
			34578158,
			33243742,
			34720090,
			46005260,
			39968821
		],
		en: {
			name: "The Full Bag Experience",
			description: "Experience a data-driven fitting with a PXG Master Fitter to find the perfect clubs for your game.  Receive one-on-one time and a full analysis for driver, woods, hybrids, irons, wedges, and putters."
		},
		fr: {
			name: "Le sac complet",
			description: "Une expérience immersive, ou les données seront utilisées pour optimiser votre performance. Vous aurez accès à un Maître ajusteur PXG pour une analyse complète de tous les bois, les fers, les cocheurs et le fer droit."
		},
		ja: {
			name: "フルバッグ体験",
			description: "PXGマスターフィッターによるデータに基づくフィッティングを体験し、お客様のゲームに最適なクラブを見つけましょう。 ドライバー、フェアウェイウッド、ハイブリッド、アイアン、ウェッジ、パターの1対1のフィッティングと詳細な分析をお受けいただけます。"
		}
	},
	luckySeven: {
		ids: [7855193, 62421161],
		en: {
			name: "Lucky 7 Combination Fitting",
			description: `The "Lucky 7" fitting lets you mix and match seven GEN7 Irons, Black Ops Irons, Sugar Daddy III Wedges, or Black Ops Hybrids at an unbeatable price.`
		},
		fr: {
			name: "Lucky 7",
			description: `Le fitting "Lucky 7" vous permet de combiner sept fers GEN7, fers Black Ops, wedges Sugar Daddy III ou hybrides Black Ops à un prix imbattable.`
		},
		ja: {
			name: "ラッキー7 コンビネーションフィッティング ",
			description: "「ラッキー7」フィッティングでは、GEN7アイアン、ブラックオプスアイアン、シュガーダディIIIウェッジ、またはブラックオプスハイブリッドを7本、お好みに合わせて組み合わせることができます。"
		}
	},
	longGame: {
		ids: [
			7855185,
			32702137,
			34721168,
			32896694
		],
		en: {
			name: "Long Game Fitting",
			description: "Enhace power distance, and consistency off the tee with our long game fitting. Spend an hour with a PXG Master Fitter who will tailor the perfect driver, fairway, and hybrid setup to boost your performance."
		},
		fr: {
			name: "Le jeu long",
			description: "Ajoutez de la puissance, de la distance et soyez plus constant avec cette séance de fitting du jeu long. Vous aurez accès à un Maître ajusteur PXG pour une analyse complète de tous les bois et hybrides."
		},
		ja: {
			name: "ロングゲームフィッティング ",
			description: "ロングゲームフィッティングで飛距離とティーショットの安定性を向上させましょう。PXGマスターフィッターが、お客様のパフォーマンスを最大限に引き出す完璧なドライバー、フェアウェイ、ハイブリッドのセッティングを1時間かけてカスタマイズします。"
		}
	},
	swingSession: {
		ids: [41057427],
		en: {
			name: "Swing Session",
			description: "Book our 30 minute swing session to experience our line up of PXG clubs."
		},
		fr: {
			name: "Essai PXG",
			description: "Réservez un rendez-vous de 30 minutes pour essayer notre gamme complète de bâtons"
		},
		ja: {
			name: "試打会",
			description: "30分間のスイングセッションをご予約いただくと、PXGのクラブラインナップをお試しいただけます。"
		}
	},
	putterFitting: {
		ids: [
			8315940,
			33243742,
			34721179,
			32896723,
			51934259
		],
		en: {
			name: "Putter Fitting",
			description: "Our putter fitting offers access to all our fully optimized Battle Ready II putters, available in blade to mallet head shapes. TrackMan Technology provided data showing which putter suits you best."
		},
		fr: {
			name: "Le putter",
			description: "Une séance de fitting PXG du fer droit, propulsée par la technologie Trackman, optimise parfaitement les fers droits Battle Ready 2 et le Allan. Disponible dans plusieurs styles, vous allez trouvez celui qui fonctionne le mieux pour vous."
		},
		ja: {
			name: "パターフィッティング",
			description: "当社のパターフィッティングでは、ブレード型からマレット型まで、すべて最適化されたバトル・レディIIパターのすべてをお試しいただけます。 TrackManテクノロジーにより、お客様に最適なパターのデータをご提供いたします。"
		}
	},
	specCheck: {
		ids: [
			8067288,
			34081734,
			34721193,
			40435940,
			56563974
		],
		en: {
			name: "Spec Check - Review Existing Equipment",
			description: ""
		},
		fr: {
			name: "Vérification des spécifications - Bâtons PXG existants",
			description: ""
		},
		ja: {
			name: "スペックチェック",
			description: ""
		}
	},
	driverFittingJapan: {
		ids: [39968834],
		en: {
			name: "Driver Fitting",
			description: ""
		},
		fr: {
			name: "Bois N°1",
			description: ""
		}
	},
	fairwayWoodAndHybridFittingJapan: {
		ids: [39968841],
		en: {
			name: "Fairway Wood and Hybrid Fitting",
			description: ""
		},
		fr: {
			name: "Fairways et Hybrides",
			description: ""
		}
	},
	wedgeFittingJapan: {
		ids: [39968863],
		en: {
			name: "Wedge Fitting",
			description: ""
		},
		fr: {
			name: "Cocheurs",
			description: ""
		}
	}
};
//#endregion
//#region src/components/Acuity/localization/phonePrefixMap.js
var phonePrefixMap = {
	"US": "+1",
	"CA": "+1",
	"GB": "+44",
	"JP": "+81",
	"IE": "+353",
	"NO": "+47",
	"SE": "+46",
	"FI": "+358",
	"EE": "+372",
	"LV": "+371",
	"PL": "+48",
	"NL": "+31",
	"BE": "+32",
	"DE": "+49",
	"SK": "+421",
	"RO": "+40",
	"BG": "+359",
	"FR": "+33",
	"IT": "+39",
	"ES": "+34",
	"PT": "+351",
	"AT": "+43",
	"LU": "+352",
	"CH": "+41"
};
//#endregion
//#region src/components/Acuity/fittingStorePayload.js
/**
* Builds the store object shape expected by SchedulerApp (selectedStoreObj) from a payload.
* @param {FittingStorePayload} payload
* @returns {{ name: string, address: string, phone: string, hrefFormattedPhoneNumber?: string }}
*/
function storeObjectFromPayload(payload) {
	return {
		name: payload.name ?? "",
		address: payload.address ?? "",
		phone: payload.phone ?? "",
		...payload.hrefFormattedPhoneNumber != null && { hrefFormattedPhoneNumber: payload.hrefFormattedPhoneNumber }
	};
}
//#endregion
//#region src/components/Acuity/localization/filterTranslations.js
var filterTranslations = {
	"fr-CA": {
		"PXG Store": "Magasin PXG",
		"Fitting Studio": "Studio Fitting PXG",
		"Rental Location": "Emplacement de location",
		"Certified Retailer": "Détaillant certifié",
		"Green Grass": "Partenaire"
	},
	"ja-JP": {
		"PXG Store": "PXG直営店",
		"Fitting Studio": "PXGフィッティング店舗",
		"Outdoor Fitting Studio": "アウトドアフィッティングスタジオ",
		"Rental Location": "レンタル店舗",
		"Certified Retailer": "正規販売店",
		"Green Grass": "相棒"
	}
};
//#endregion
//#region src/components/Acuity/storeRocketAcuityAdapter.js
/**
* StoreRocket map widget adapter for the Acuity fitting scheduler.
* Builds a data-only store payload from StoreRocket DOM and calls the global
* startAcuityFitting(storeData) API. Also attaches filter/card/CTA translation
* helpers expected by assets/storerocket-handler.js.
*/
var fullLocaleString = typeof Shopify !== "undefined" ? `${Shopify.locale}-${Shopify.country}` : "en-US";
function formatTelNoforHref(number, storeCountry) {
	let strippedNumber = (number ?? "").replace(/\D/g, "");
	if (![
		"US",
		"CA",
		"LU"
	].includes(storeCountry) && strippedNumber.charAt(0) === "0") strippedNumber = strippedNumber.slice(1);
	let localePhonePrefix = "+1";
	if (storeCountry && Object.keys(phonePrefixMap).includes(storeCountry)) localePhonePrefix = phonePrefixMap[storeCountry];
	return `tel:${localePhonePrefix + strippedNumber}`;
}
/**
* Build a FittingStorePayload from StoreRocket CTA data and the clicked element's DOM.
* @param {{ link?: string, locale?: string, calendarIds: number[] }} data - From CTA href JSON
* @param {Element} selectedElement - The clicked link/card element
* @returns {import('./fittingStorePayload').FittingStorePayload}
*/
function buildStorePayloadFromDom(data, selectedElement) {
	const isOverlaySelected = selectedElement.classList.contains("storerocket-overlay-details-custom-ctas-item");
	const parentElement = isOverlaySelected ? selectedElement.parentElement.parentElement.parentElement : selectedElement.parentElement.parentElement;
	const baseSelector = isOverlaySelected ? ".storerocket-overlay-details" : ".storerocket-result";
	const storeName = parentElement.querySelector(`${baseSelector}-name`)?.textContent?.trim() ?? "";
	let addressLineOne;
	let addressCountry;
	if (isOverlaySelected) {
		addressLineOne = parentElement.querySelector(`${baseSelector}-address-line1`)?.textContent?.trim() ?? "";
		addressCountry = parentElement.querySelector(`${baseSelector}-address-country`)?.textContent?.trim() ?? "";
	} else {
		addressLineOne = parentElement.querySelector(`${baseSelector}-address-line-1`)?.textContent?.trim() ?? "";
		addressCountry = parentElement.querySelector(`${baseSelector}-country`)?.textContent?.trim() ?? "";
	}
	const addressCity = parentElement.querySelector(`${baseSelector}-address-city`)?.textContent?.trim() ?? "";
	const addressPostCode = parentElement.querySelector(`${baseSelector}-address-postcode`)?.textContent?.trim() ?? "";
	let addressStatePostCode;
	if (parentElement.querySelector(`${baseSelector}-address-state`)) addressStatePostCode = `${parentElement.querySelector(`${baseSelector}-address-state`)?.textContent?.trim() ?? ""} ${addressPostCode}`;
	else addressStatePostCode = addressPostCode;
	const storeAddress = `${addressLineOne}, ${addressCity}, ${addressStatePostCode}`;
	let storePhone = "";
	if (!isOverlaySelected) {
		const phoneEl = parentElement.querySelector(".storerocket-result-phone");
		if (phoneEl) storePhone = phoneEl.textContent?.trim() ?? "";
	} else {
		const phoneAction = parentElement.querySelector(".storerocket-overlay-details-action--phone");
		if (phoneAction) {
			const a = phoneAction.querySelector("a");
			if (a) storePhone = a.textContent?.trim() ?? "";
		}
	}
	const hrefFormattedPhoneNumber = formatTelNoforHref(storePhone, addressCountry);
	return {
		name: storeName,
		address: storeAddress,
		phone: storePhone,
		country: addressCountry,
		hrefFormattedPhoneNumber,
		calendarIds: data.calendarIds ?? [],
		locale: data.locale ?? null
	};
}
var filterActivated = false;
function filterOptionsTranslateAndPreSelect(element, urlParamFilters) {
	let preSelectedFilters;
	if (urlParamFilters) preSelectedFilters = urlParamFilters.split(",");
	else if (typeof Shopify !== "undefined" && (Shopify.country === "US" || Shopify.country === "CA" || Shopify.country === "GB")) preSelectedFilters = [
		"139823",
		"139817",
		"139821"
	];
	else preSelectedFilters = ["139823", "139817"];
	const doTranslate = !!filterTranslations?.[fullLocaleString];
	element.querySelectorAll(".storerocket-overlay-list-item-name").forEach((item) => {
		if (doTranslate && filterTranslations[fullLocaleString][item.textContent?.trim()]) item.textContent = filterTranslations[fullLocaleString][item.textContent.trim()];
		if (preSelectedFilters.includes(item.parentElement?.dataset?.filter)) {
			item.parentElement?.classList?.add("is-active");
			filterActivated = true;
		}
	});
	if (document.querySelector(".storerocket-map-switch-units-kilometers") && typeof Shopify !== "undefined" && (Shopify.country === "JP" || Shopify.country === "CA")) document.querySelector(".storerocket-map-switch-units-kilometers").click();
}
function storeCardLocalization(element) {
	if (element.classList.contains("storerocket-overlay-filters-item")) {
		const storeCountry = element.parentElement?.parentElement?.parentElement?.querySelector(".storerocket-overlay-details-address-country")?.textContent?.trim();
		const phoneLink = element.parentElement?.parentElement?.querySelector(".storerocket-overlay-details-action--phone")?.querySelector("a");
		if (phoneLink && storeCountry) {
			const currentHref = phoneLink.getAttribute("href");
			if (currentHref) phoneLink.setAttribute("href", formatTelNoforHref(currentHref, storeCountry));
		}
	}
	if (!filterTranslations[fullLocaleString]) return;
	const key = element.textContent?.trim();
	if (key && filterTranslations[fullLocaleString][key]) element.textContent = filterTranslations[fullLocaleString][key];
}
function ctaTranslatorAndFilterApply(element) {
	if (filterActivated) {
		document.querySelector(".storerocket-overlay-filters-apply-button")?.click();
		filterActivated = false;
	}
	if (!filterTranslations[fullLocaleString]) return;
	const upperText = (element.textContent ?? "").toUpperCase();
	if (upperText.includes("BOOK A FITTING") || upperText.includes("BOOK NOW")) {
		if (fullLocaleString === "fr-CA") element.textContent = "RÉSERVEZ VOTRE AJUSTEMENT SUR MESURE";
		else if (fullLocaleString === "ja-JP") element.textContent = "フィッティングを予約";
	} else if (upperText.includes("STORE DETAILS")) {
		if (fullLocaleString === "fr-CA") element.textContent = "DÉTAILS SUR LE MAGASIN";
		else if (fullLocaleString === "ja-JP") element.textContent = "店舗詳細";
	}
}
var storedGlobals = {
	bookAcuityFitting: null,
	startFittingFlow: null,
	filterOptionsTranslateAndPreSelect: null,
	storeCardLocalization: null,
	ctaTranslatorAndFilterApply: null
};
/**
* Register StoreRocket-specific globals so storerocket-handler.js can call them.
* Must be called after window.startAcuityFitting is set (by SchedulerApp).
*/
function registerStoreRocketAdapter() {
	storedGlobals.bookAcuityFitting = window.bookAcuityFitting;
	storedGlobals.startFittingFlow = window.startFittingFlow;
	storedGlobals.filterOptionsTranslateAndPreSelect = window.filterOptionsTranslateAndPreSelect;
	storedGlobals.storeCardLocalization = window.storeCardLocalization;
	storedGlobals.ctaTranslatorAndFilterApply = window.ctaTranslatorAndFilterApply;
	window.bookAcuityFitting = async (data, selectedElement) => {
		const payload = buildStorePayloadFromDom(data, selectedElement);
		if (typeof window.startAcuityFitting === "function") await window.startAcuityFitting(payload);
	};
	window.startFittingFlow = () => {
		const btn = document.querySelector(".storerocket-result-button");
		if (btn) btn.click();
	};
	window.filterOptionsTranslateAndPreSelect = filterOptionsTranslateAndPreSelect;
	window.storeCardLocalization = storeCardLocalization;
	window.ctaTranslatorAndFilterApply = ctaTranslatorAndFilterApply;
}
/**
* Restore previous window handlers (if any) and remove adapter globals.
*/
function unregisterStoreRocketAdapter() {
	if (storedGlobals.bookAcuityFitting != null) window.bookAcuityFitting = storedGlobals.bookAcuityFitting;
	else delete window.bookAcuityFitting;
	if (storedGlobals.startFittingFlow != null) window.startFittingFlow = storedGlobals.startFittingFlow;
	else delete window.startFittingFlow;
	if (storedGlobals.filterOptionsTranslateAndPreSelect != null) window.filterOptionsTranslateAndPreSelect = storedGlobals.filterOptionsTranslateAndPreSelect;
	else delete window.filterOptionsTranslateAndPreSelect;
	if (storedGlobals.storeCardLocalization != null) window.storeCardLocalization = storedGlobals.storeCardLocalization;
	else delete window.storeCardLocalization;
	if (storedGlobals.ctaTranslatorAndFilterApply != null) window.ctaTranslatorAndFilterApply = storedGlobals.ctaTranslatorAndFilterApply;
	else delete window.ctaTranslatorAndFilterApply;
}
//#endregion
//#region src/components/Acuity/SchedulerApp.jsx
var TRACK_TIME_APPOINTMENT_TYPE_IDS = /* @__PURE__ */ new Set([93443767, 95580166]);
var isTrackTimeAppointmentType = (id) => TRACK_TIME_APPOINTMENT_TYPE_IDS.has(Number(id));
/** Stop waiting for work types after this long and show the call-support fallback instead of a blank section. */
var SCHEDULER_LOAD_TIMEOUT_MS = 15e3;
/** Scroll a section into view and move keyboard focus so it does not remain on the triggering CTA. */
var scrollIntoViewAndFocus = (el) => {
	if (!el) return;
	el.scrollIntoView({ behavior: "smooth" });
	el.focus({ preventScroll: true });
};
var SchedulerApp = ({ initialStoreData = null, loggedInCustomerData: loggedInCustomerDataProp = null, onSwitchLocation = null, enableMapObserver = true, showSwitchLocation = null }) => {
	const { translations } = useFittingTranslations();
	const [selectedStoreObj, setSelectedStoreObj] = (0, import_react.useState)({
		name: "",
		type: "",
		address: "",
		phone: ""
	});
	const [selectedStoreName, setSelectedStoreName] = (0, import_react.useState)(null);
	const [selectedCalendarIds, setSelectedCalendarIds] = (0, import_react.useState)(null);
	const [filteredWorkTypes, setFilteredWorkTypes] = (0, import_react.useState)([]);
	const [trackTimeWorkType, setTrackTimeWorkType] = (0, import_react.useState)(null);
	const [addOn, setAddOn] = (0, import_react.useState)({});
	const [selectedWorkTypeAvailableAddOns, setSelectedWorkTypeAvailableAddOns] = (0, import_react.useState)(null);
	const [selectedWorkTypeId, setSelectedWorkTypeId] = (0, import_react.useState)(null);
	const [selectedAppointment, setSelectedAppointment] = (0, import_react.useState)(false);
	const [finalBookingObject, setFinalBookingObject] = (0, import_react.useState)({});
	const workTypesRef = (0, import_react.useRef)(null);
	const calendarRef = (0, import_react.useRef)(null);
	const finalBookingRef = (0, import_react.useRef)(null);
	const [loggedInCustomerDataState, setLoggedInCustomerDataState] = (0, import_react.useState)(null);
	const [renderScheduler, setRenderScheduler] = (0, import_react.useState)(false);
	const [refreshCalendar, setRefreshCalendar] = (0, import_react.useState)(false);
	const [selectedTime, setSelectedTime] = (0, import_react.useState)(null);
	const fullLocaleString = `${Shopify.locale}-${Shopify.country}`;
	const [storeAcuityLocale, setStoreAcuityLocale] = (0, import_react.useState)(null);
	const [fetchedStartDates, setFetchedStartDates] = (0, import_react.useState)([]);
	const [firstDateToQuery, setFirstDateToQuery] = (0, import_react.useState)(/* @__PURE__ */ new Date());
	const [hasMapContainer, setHasMapContainer] = (0, import_react.useState)(false);
	const [startedFromInitialStoreScript, setStartedFromInitialStoreScript] = (0, import_react.useState)(false);
	const [schedulerUnavailable, setSchedulerUnavailable] = (0, import_react.useState)(false);
	const reportedUnavailableRef = (0, import_react.useRef)(false);
	const loggedInCustomerData = loggedInCustomerDataProp ?? loggedInCustomerDataState;
	let hour12Format = true;
	if (fullLocaleString === "fr-CA") hour12Format = false;
	const workTypeTranslator = (workTypeToTranslate, userLocaleLanguage) => {
		for (const workType in workTypeTranslations) if (workTypeTranslations[workType].ids.includes(workTypeToTranslate.id)) {
			workTypeToTranslate.name = workTypeTranslations[workType][userLocaleLanguage].name;
			workTypeToTranslate.description = workTypeTranslations[workType][userLocaleLanguage].description;
		}
	};
	const dataLayerErrorHandler = (0, import_react.useCallback)((event, fittingStep, errorType, errorMessage) => {
		pushFittingError({
			event,
			fittingStep,
			errorType,
			errorMessage,
			calendarIds: selectedCalendarIds,
			locale: storeAcuityLocale,
			selectedWorkTypeId
		});
	}, [
		selectedCalendarIds,
		storeAcuityLocale,
		selectedWorkTypeId
	]);
	/**
	* Replace the scheduler with the "call Player Support" message and report why (once per booking attempt).
	* @param {string} reason
	* @param {Record<string, unknown>} [details]
	*/
	const showSchedulerUnavailable = (0, import_react.useCallback)((reason, details = {}) => {
		setRenderScheduler(true);
		setSchedulerUnavailable(true);
		if (reportedUnavailableRef.current) return;
		reportedUnavailableRef.current = true;
		posthog_default.capture("fitting_scheduler_unavailable", {
			reason,
			page_path: window.location.pathname,
			...details
		});
	}, []);
	const handleFilterWorkTypes = async (storeName, storeCalendarIds) => {
		if (!renderScheduler) return;
		try {
			const httpResponse = await fetch(`https://${Shopify.pxgApiEndpoint}/acuity/appointment-types`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					calendarIds: storeCalendarIds,
					locale: storeAcuityLocale
				})
			});
			if (!httpResponse.ok) {
				const err = /* @__PURE__ */ new Error(`Server error: ${httpResponse.status}`);
				err.status = httpResponse.status;
				throw err;
			}
			const response = await httpResponse.json();
			const appointmentTypes = Array.isArray(response?.appointmentTypes) ? response.appointmentTypes : [];
			if (!appointmentTypes.some((workType) => workType.calendarIds?.some((id) => storeCalendarIds.includes(id)) && (!workType.private || isTrackTimeAppointmentType(workType.id)))) {
				console.error("No bookable appointment types returned for", storeName);
				showSchedulerUnavailable("no_appointment_types", {
					location_name: storeName,
					calendar_ids: storeCalendarIds,
					locale: storeAcuityLocale,
					appointment_type_count: appointmentTypes.length
				});
				return;
			}
			pushBeginFitting({ locationName: storeName });
			posthog_default.capture("fitting_started", { location_name: storeName });
			const storeLocaleLang = storeAcuityLocale.split("_")[0];
			const userLocaleLang = fullLocaleString.split("-")[0];
			const translateWorkType = storeLocaleLang !== userLocaleLang;
			const prepareWorkType = (workType) => {
				if (translateWorkType) workTypeTranslator(workType, userLocaleLang);
				workType.name = normalizeFittingType(workType.name);
				workType.durationUnits = userLocaleLang === "ja" ? "分" : "Min";
				return workType;
			};
			const filteredResponseWorkTypes = response.appointmentTypes.filter((workType) => {
				return workType.calendarIds.some((id) => storeCalendarIds.includes(id)) && !workType.private && !isTrackTimeAppointmentType(workType.id);
			}).map(prepareWorkType);
			setFilteredWorkTypes(filteredResponseWorkTypes);
			setSchedulerUnavailable(false);
			const trackTimeFromApi = response.appointmentTypes.find((workType) => isTrackTimeAppointmentType(workType.id) && workType.calendarIds.some((id) => storeCalendarIds.includes(id)));
			setTrackTimeWorkType(trackTimeFromApi ? prepareWorkType(trackTimeFromApi) : null);
			let addOnIdsFromFilteredWorkTypes = /* @__PURE__ */ new Set();
			filteredResponseWorkTypes.forEach(({ addonIds }) => {
				addonIds.forEach((addonId) => addOnIdsFromFilteredWorkTypes.add(addonId));
			});
			if (response.appointmentAddons.length > 0) setAddOn(response.appointmentAddons.find((addOn) => addOnIdsFromFilteredWorkTypes.has(addOn.id) && !addOn.private));
			else setAddOn(null);
			if (storeName !== selectedStoreName) {
				setSelectedWorkTypeId(null);
				setSelectedAppointment(false);
				setFetchedStartDates([]);
				setFirstDateToQuery(/* @__PURE__ */ new Date());
			}
			setSelectedCalendarIds(storeCalendarIds);
			setSelectedStoreName(storeName);
			if (!startedFromInitialStoreScript) setTimeout(() => {
				scrollIntoViewAndFocus(workTypesRef.current);
			});
		} catch (error) {
			let errorType = "FrontEnd JS";
			if (error.status) errorType = "Server Error";
			else if (error instanceof TypeError) errorType = "Network";
			const serializedError = {
				name: error.name || "Unknown error name",
				message: error.message || "Unknown error message",
				stack: error.stack || "Unknown error stack"
			};
			dataLayerErrorHandler("dl_fitting_error", "beginFitting", errorType, JSON.stringify(serializedError));
			console.error("Error fetching work types:", serializedError);
			showSchedulerUnavailable("work_types_request_failed", {
				location_name: storeName,
				calendar_ids: storeCalendarIds,
				error_type: errorType,
				error_message: serializedError.message,
				http_status: error.status ?? null
			});
		}
	};
	(0, import_react.useEffect)(() => {
		if (!enableMapObserver) return;
		const MAP_POLL_TIMEOUT_MS = 1e4;
		const MAP_POLL_INTERVAL_MS = 500;
		let intervalId = null;
		let observerInstance = null;
		intervalId = setInterval(() => {
			const mapPinsWrapper = document.querySelector(".gm-style");
			if (!mapPinsWrapper) return;
			clearInterval(intervalId);
			intervalId = null;
			observerInstance = new MutationObserver(() => {
				mapPinsWrapper.querySelectorAll("div[tabindex=\"-1\"]").forEach((pin) => pin.setAttribute("tabindex", "0"));
			});
			observerInstance.observe(mapPinsWrapper, {
				childList: true,
				attributes: true,
				subtree: true,
				characterData: true
			});
		}, MAP_POLL_INTERVAL_MS);
		const timeoutId = setTimeout(() => {
			if (intervalId) {
				clearInterval(intervalId);
				intervalId = null;
			}
		}, MAP_POLL_TIMEOUT_MS);
		return () => {
			clearTimeout(timeoutId);
			if (intervalId) clearInterval(intervalId);
			if (observerInstance) observerInstance.disconnect();
		};
	}, [enableMapObserver]);
	(0, import_react.useEffect)(() => {
		if (loggedInCustomerDataProp != null) return;
		const c = typeof window !== "undefined" ? window.Shopify?.customer : void 0;
		if (!c) return;
		setLoggedInCustomerDataState({
			customerFirstName: c.firstName,
			customerLastName: c.lastName,
			customerEmail: c.email,
			customerPhone: c.phone,
			customerAcceptsMarketing: c.acceptsMarketing
		});
	}, [loggedInCustomerDataProp]);
	(0, import_react.useEffect)(() => {
		setHasMapContainer(!!document.querySelector("#locations-component"));
	}, []);
	(0, import_react.useEffect)(() => {
		window.__acuityFittingContext = {
			storeName: selectedStoreName,
			storeAcuityLocale
		};
		return () => {
			delete window.__acuityFittingContext;
		};
	}, [selectedStoreName, storeAcuityLocale]);
	(0, import_react.useEffect)(() => {
		if (renderScheduler && selectedStoreObj.name && selectedCalendarIds) handleFilterWorkTypes(selectedStoreObj.name, selectedCalendarIds);
	}, [
		renderScheduler,
		selectedStoreObj.name,
		selectedCalendarIds
	]);
	const formatTelNoforHref = (number, storeCountry) => {
		let strippedNumber = (number ?? "").replace(/\D/g, "");
		if (![
			"US",
			"CA",
			"LU"
		].includes(storeCountry) && strippedNumber.charAt(0) === "0") strippedNumber = strippedNumber.slice(1);
		let localePhonePrefix = "+1";
		if (storeCountry && Object.keys(phonePrefixMap).includes(storeCountry)) localePhonePrefix = phonePrefixMap[storeCountry];
		return `tel:${localePhonePrefix + strippedNumber}`;
	};
	/**
	* Data-only API: start the scheduler with a store payload (no DOM). Called by adapter or other entry points.
	* @param {FittingStorePayload} storeData
	* @param {{ scrollToWorkTypes?: boolean }} [options] - If scrollToWorkTypes is false, do not scroll to the scheduler (e.g. on store page where section is already in view).
	*/
	const startFitting = (0, import_react.useCallback)(async (storeData, options = {}) => {
		const { scrollToWorkTypes = true } = options;
		const storeObj = storeObjectFromPayload(storeData);
		const hrefFormattedPhoneNumber = storeData.hrefFormattedPhoneNumber ?? (storeData.phone && storeData.country ? formatTelNoforHref(storeData.phone, storeData.country) : "");
		if (hrefFormattedPhoneNumber) storeObj.hrefFormattedPhoneNumber = hrefFormattedPhoneNumber;
		reportedUnavailableRef.current = false;
		setSchedulerUnavailable(false);
		if (!storeData.calendarIds?.length) {
			showSchedulerUnavailable("missing_calendar_ids", { location_name: storeData.name ?? "" });
			return;
		}
		if (storeData.locale) setStoreAcuityLocale(storeData.locale);
		setRenderScheduler(true);
		setSelectedCalendarIds(storeData.calendarIds ?? []);
		setSelectedStoreObj(storeObj);
		if (scrollToWorkTypes) setTimeout(() => {
			scrollIntoViewAndFocus(workTypesRef.current);
		}, 500);
		const storeName = storeData.name ?? "";
		if (typeof window !== "undefined" && window.featureToggle?.preferredStoreUXEnabled && storeName !== "PXG Phone Fitting") if (storeData.pxgMatchedStore) {
			const pxgMatchedStore = storeData.pxgMatchedStore;
			if (window.setStoreCookie && window.getStoreCookiePayload && window.updateLocationUI) {
				window.setStoreCookie(window.getStoreCookiePayload(pxgMatchedStore, "selected"));
				window.updateLocationUI(pxgMatchedStore.name, pxgMatchedStore.lat, pxgMatchedStore.lng);
			}
		} else try {
			const res = await fetch(`/apps/pxg/v1/store-detail?name=${encodeURIComponent(storeName)}`, {
				method: "GET",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json"
				}
			});
			if (res.ok) {
				const pxgMatchedStore = (await res.json()).store;
				if (window.setStoreCookie && window.getStoreCookiePayload && window.updateLocationUI && pxgMatchedStore) {
					window.setStoreCookie(window.getStoreCookiePayload(pxgMatchedStore, "selected"));
					window.updateLocationUI(pxgMatchedStore.name, pxgMatchedStore.lat, pxgMatchedStore.lng);
				}
			}
		} catch (err) {
			console.error("Error fetching store:", err);
		}
	}, [showSchedulerUnavailable]);
	(0, import_react.useEffect)(() => {
		window.startAcuityFitting = startFitting;
		window.showAcuityFittingUnavailable = showSchedulerUnavailable;
		registerStoreRocketAdapter();
		return () => {
			delete window.startAcuityFitting;
			delete window.showAcuityFittingUnavailable;
			unregisterStoreRocketAdapter();
		};
	}, [startFitting, showSchedulerUnavailable]);
	const hasLoadedWorkTypes = filteredWorkTypes.length > 0 || Boolean(trackTimeWorkType);
	(0, import_react.useEffect)(() => {
		if (!renderScheduler || hasLoadedWorkTypes || schedulerUnavailable) return;
		const timeoutId = setTimeout(() => {
			showSchedulerUnavailable("timeout", {
				location_name: selectedStoreObj.name,
				timeout_ms: SCHEDULER_LOAD_TIMEOUT_MS
			});
		}, SCHEDULER_LOAD_TIMEOUT_MS);
		return () => clearTimeout(timeoutId);
	}, [
		renderScheduler,
		hasLoadedWorkTypes,
		schedulerUnavailable,
		selectedStoreObj.name,
		showSchedulerUnavailable
	]);
	(0, import_react.useEffect)(() => {
		if (!initialStoreData?.calendarIds?.length) return;
		startFitting(initialStoreData);
	}, []);
	(0, import_react.useEffect)(() => {
		if (initialStoreData?.calendarIds?.length) return;
		const scriptEl = document.getElementById("acuity-initial-store");
		if (!scriptEl?.textContent) return;
		let parsed;
		try {
			parsed = JSON.parse(scriptEl.textContent);
		} catch (err) {
			console.error("Invalid acuity-initial-store JSON:", err);
			return;
		}
		const storeName = parsed.storeName;
		if (!storeName || typeof storeName !== "string") return;
		setStartedFromInitialStoreScript(true);
		(async () => {
			try {
				const res = await fetch(`/apps/pxg/v1/store-detail?name=${encodeURIComponent(storeName)}`, {
					method: "GET",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json"
					}
				});
				if (!res.ok) throw new Error(`store-detail ${res.status}`);
				const store = (await res.json()).store;
				if (!store) throw new Error("store-detail missing store");
				const bookFittingCta = store.callsToAction?.find((cta) => cta.title && cta.title.toUpperCase() === "BOOK A FITTING" || typeof cta.value === "string" && /calendarIds/.test(cta.value));
				if (!bookFittingCta?.value) throw new Error("BOOK A FITTING CTA not found");
				const ctaJsonStr = bookFittingCta.value.replace(/'/g, "\"");
				let ctaData;
				try {
					ctaData = JSON.parse(ctaJsonStr);
				} catch (e) {
					throw new Error(`Failed to parse BOOK A FITTING CTA value: ${e.message}`);
				}
				const calendarIds = ctaData.calendarIds;
				const locale = ctaData.locale;
				if (!Array.isArray(calendarIds) || calendarIds.length === 0) throw new Error("CTA missing calendarIds");
				const payload = {
					name: store.name ?? parsed.storeName ?? "",
					address: parsed.address ?? store.display_address ?? store.address ?? "",
					phone: parsed.phone ?? store.phone ?? "",
					country: parsed.country ?? store.country ?? "",
					calendarIds,
					locale: locale ?? null,
					pxgMatchedStore: store
				};
				startFitting(payload, { scrollToWorkTypes: false });
			} catch (err) {
				console.error("Error starting fitting from acuity-initial-store:", err);
				showSchedulerUnavailable("store_detail_failed", {
					location_name: storeName,
					error_message: err instanceof Error ? err.message : String(err)
				});
			}
		})();
	}, [
		initialStoreData?.calendarIds?.length,
		startFitting,
		showSchedulerUnavailable
	]);
	const handleWorkTypeSelection = (workType) => {
		setSelectedWorkTypeId(workType.id);
		setSelectedWorkTypeAvailableAddOns(workType.addonIds);
		setSelectedTime(null);
		setSelectedAppointment(false);
		setFetchedStartDates([]);
		setFirstDateToQuery(/* @__PURE__ */ new Date());
		setFinalBookingObject((prevState) => ({
			...prevState,
			appointmentTypeId: workType.id,
			workTypeName: workType.name,
			workType: {
				name: workType.name,
				description: workType.description,
				duration: workType.duration
			}
		}));
		posthog_default.capture("fitting_type_selected", {
			fitting_type: normalizeFittingType(workType.name),
			fitting_type_id: workType.id,
			location_name: selectedStoreName
		});
		setTimeout(() => {
			scrollIntoViewAndFocus(calendarRef.current);
		}, 500);
	};
	const handleAppointmentSelect = (slotTime, slotCalendarId, slotTimeZone) => {
		setSelectedAppointment(true);
		setFinalBookingObject((prevState) => ({
			...prevState,
			dateTime: slotTime,
			dateTimeReadable: getDateFromIso(slotTime, "fullDateTime", false, slotTimeZone),
			calendarId: slotCalendarId
		}));
		setSelectedTime(slotTime);
		setTimeout(() => {
			scrollIntoViewAndFocus(finalBookingRef.current);
		}, 500);
		pushSelectAppointment({
			locationName: selectedStoreName,
			fittingExperience: finalBookingObject.workTypeName,
			appointmentDate: getDateFromIso(slotTime, "fullDateTime", false, slotTimeZone)
		});
		posthog_default.capture("fitting_time_selected", {
			fitting_type: normalizeFittingType(finalBookingObject.workTypeName),
			fitting_type_id: finalBookingObject.appointmentTypeId,
			location_name: selectedStoreName
		});
	};
	const handleBookingFailure = (0, import_react.useCallback)((options = {}) => {
		setSelectedTime(null);
		setRefreshCalendar(true);
		if (!options.blockFurtherSubmits) setTimeout(() => {
			scrollIntoViewAndFocus(calendarRef.current);
		});
	}, []);
	const bookAnotherAppointmentHandler = (bookingSuccess) => {
		setSelectedAppointment(null);
		if (bookingSuccess) {
			setSelectedWorkTypeId(null);
			setFetchedStartDates([]);
			setFirstDateToQuery(/* @__PURE__ */ new Date());
			setTimeout(() => {
				scrollIntoViewAndFocus(workTypesRef.current);
			});
		} else {
			setTimeout(() => {
				scrollIntoViewAndFocus(calendarRef.current);
			});
			setRefreshCalendar(true);
		}
	};
	if (!renderScheduler) return null;
	if (schedulerUnavailable) return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
		className: "page-width py-8",
		children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingErrorMessage, { message: translations?.schedulerUnavailableText || translations?.noAppointmentsHelpText })
	});
	if (!hasLoadedWorkTypes) return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingIndicator, {});
	const capitalizeFirstLetters = (str) => {
		return str.split(" ").map((word) => {
			return word.charAt(0).toUpperCase() + word.slice(1);
		}).join(" ");
	};
	const getDateFromIso = (dateInput, type, bypassDateSetup = false, timeZone) => {
		const date = bypassDateSetup ? dateInput : new Date(dateInput);
		let returnString;
		switch (type) {
			case "day":
				returnString = date.toLocaleDateString(fullLocaleString, { weekday: "long" });
				break;
			case "shortDay":
				returnString = date.toLocaleDateString(fullLocaleString, { weekday: "short" });
				break;
			case "month":
				returnString = date.toLocaleDateString(fullLocaleString, { month: "long" });
				break;
			case "shortMonth":
				returnString = date.toLocaleDateString(fullLocaleString, { month: "short" });
				break;
			case "monthDayShort":
				returnString = date.toLocaleDateString(fullLocaleString, {
					month: "short",
					day: "numeric"
				});
				break;
			case "fullDateTime":
				let returnDate = date.toLocaleDateString(fullLocaleString, {
					weekday: "long",
					month: "long",
					day: "numeric"
				});
				if (fullLocaleString === "fr-CA") returnDate = capitalizeFirstLetters(returnDate);
				const returnTime = date.toLocaleTimeString(fullLocaleString, {
					hour: "numeric",
					minute: "2-digit",
					hour12: hour12Format,
					timeZone
				});
				returnString = `${returnDate} - ${returnTime}`;
				break;
			default:
				returnString = date.toLocaleDateString(fullLocaleString, {
					month: "long",
					day: "numeric"
				});
				break;
		}
		if (fullLocaleString === "fr-CA" && type !== "fullDateTime") returnString = capitalizeFirstLetters(returnString);
		return returnString;
	};
	const getDateFromString = (dateString, type = null) => {
		const [year, month, day] = dateString.split("-").map(Number);
		const date = new Date(year, month - 1, day);
		return getDateFromIso(date, type, true);
	};
	function changeLocationHandler() {
		const storeRocketOverlay = document.querySelector("#storerocket-overlay");
		let storerocketSingleStoreUI = false;
		if (storeRocketOverlay?.classList?.contains("is-open")) {
			storeRocketOverlay.classList.remove("is-open", "is-visible");
			storerocketSingleStoreUI = true;
		}
		if (new URLSearchParams(window.location.search).has("location")) storerocketSingleStoreUI = true;
		const clearBtn = document.querySelector(".storerocket-clear-search");
		if (clearBtn?.offsetParent != null) clearBtn.click();
		document.querySelector("#storerocket-map-container button.gm-ui-hover-effect")?.click();
		if (storerocketSingleStoreUI) {
			const searchInputField = document.querySelector(".storerocket-search-field");
			if (searchInputField) {
				searchInputField.value = selectedStoreObj.address ?? "";
				searchInputField.dispatchEvent(new KeyboardEvent("keydown", {
					bubbles: true,
					cancelable: true,
					key: "Enter",
					code: "Enter",
					keyCode: 13
				}));
			}
		}
		const mapScrollToId = document.querySelector("#locations-component");
		if (mapScrollToId) mapScrollToId.scrollIntoView({ behavior: "smooth" });
		pushChangeLocation({ locationName: selectedStoreName });
	}
	const handleSwitchLocationClick = () => {
		if (typeof onSwitchLocation === "function") {
			onSwitchLocation();
			pushChangeLocation({ locationName: selectedStoreName });
		} else changeLocationHandler();
	};
	return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [showSwitchLocation !== false && (onSwitchLocation != null || hasMapContainer && !startedFromInitialStoreScript) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
		className: "mb-6 text-center",
		children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
			onClick: handleSwitchLocationClick,
			className: "btn btn--secondary rounded-b-lg rounded-t-none border-t-0 px-4 py-2",
			children: translations?.switchLocationButtonText
		})
	}), /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
		className: "page-width flex scroll-mt-[var(--nav-height)] flex-col gap-10 outline-none",
		ref: workTypesRef,
		tabIndex: -1,
		children: [
			/* @__PURE__ */ (0, import_jsx_runtime.jsx)(WorkTypes, {
				filteredWorkTypes,
				onWorkTypeSelect: handleWorkTypeSelection,
				selectedWorkTypeId,
				selectedStoreName: selectedStoreObj.name,
				selectedStoreObj
			}),
			trackTimeWorkType ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(WorkTypesTrackTime, {
				translations,
				workType: trackTimeWorkType,
				onWorkTypeSelect: handleWorkTypeSelection,
				selectedWorkTypeId
			}) : null,
			selectedWorkTypeId && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Calendar, {
				calendarRef,
				workTypeId: selectedWorkTypeId,
				onlyTodayAndTomorrow: isTrackTimeAppointmentType(selectedWorkTypeId),
				calendarIds: selectedCalendarIds,
				onAppointmentSelect: handleAppointmentSelect,
				refreshCalendar,
				setRefreshCalendar,
				selectedTime,
				getDateFromString,
				fullLocaleString,
				storeAcuityLocale,
				hour12Format,
				capitalizeFirstLetters,
				selectedStoreName,
				workTypeName: finalBookingObject.workTypeName,
				dataLayerErrorHandler,
				fetchedStartDates,
				setFetchedStartDates,
				firstDateToQuery,
				setFirstDateToQuery
			}),
			selectedAppointment && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FinalBooking, {
				selectedStoreObj,
				finalBookingObject,
				finalBookingRef,
				bookAnotherAppointmentHandler,
				onBookingFailure: handleBookingFailure,
				selectedTime,
				storeAcuityLocale,
				dataLayerErrorHandler,
				addOn,
				selectedWorkTypeAvailableAddOns,
				selectedCalendarIds,
				loggedInCustomerData
			})
		]
	})] });
};
//#endregion
//#region src/entrypoints/fitting.jsx
/** @type {import('~/types/fitting').FittingTranslations | null} */
var INITIAL_TRANSLATIONS = null;
function FittingApp() {
	const [translations, setTranslations] = (0, import_react.useState)(INITIAL_TRANSLATIONS);
	(0, import_react.useEffect)(() => {
		setTranslations(parseFittingTranslationsFromDom());
	}, []);
	return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingTranslationsProvider, {
		translations,
		children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SchedulerApp, {})
	});
}
var fittingAppMountingElement = document.getElementById("acuity-app");
if (fittingAppMountingElement) (0, import_client.createRoot)(fittingAppMountingElement).render(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.StrictMode, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FittingApp, {}) }));
//#endregion
